import { useState, useEffect } from 'react';

const useFetchRestaurantReviews = (restaurantId) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!restaurantId) {
      setLoading(false);
      return;
    }

    const fetchReviews = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/reviews/restaurant/${restaurantId}`,
          {
            method: 'GET',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (!response.ok) {
          throw new Error('Failed to fetch reviews');
        }

        const data = await response.json();
        if (data.success) {
          setReviews(data.data || []);
        } else {
          setReviews([]);
        }
        setError(null);
      } catch (err) {
        console.error('Error fetching restaurant reviews:', err);
        setError(err.message);
        setReviews([]);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, [restaurantId]);

  return { reviews, loading, error };
};

export default useFetchRestaurantReviews;

